__turbopack_context__.v({
  "btn": "Default-module__stTpPq__btn",
  "isWideView": "Default-module__stTpPq__isWideView",
  "wrapper": "Default-module__stTpPq__wrapper",
});
